import { Accordion } from "@material-ui/core";
import { useState, useEffect } from "react"

export const SemiControlledAccordion = (props: any) => {

    const { defaultOpen = false, ...rest } = props
    const [expanded, setExpanded] = useState(defaultOpen);

    useEffect(() => {
        setExpanded(defaultOpen)
    }, [defaultOpen])

    return (
        <Accordion expanded={expanded} onChange={() => setExpanded(!expanded)} {...rest} />
    )
}